import http from "../http-common";

class ContactService {
    create(data) {
        return http.post("/api/v1/contacts", data);
    }
}

export default new ContactService();